import { IntegrationService } from '../../../../../../services/exports/Constants';

export default {
  title: 'Integrazioni',
  services: {
    [IntegrationService.Tabless]: 'Tabless',
    [IntegrationService.WinOrder]: 'WinOrder',
    [IntegrationService.ExpertOrder]: 'ExpertOrder',
    [IntegrationService.Deliverect]: 'Deliverect',
    [IntegrationService.Liefersoft]: 'Liefersoft',
    [IntegrationService.Hubrise]: 'HubRise',
  },
  labels: {
    no_integrations: '{{company}} non ha integrazioni configurate.',
  },
  buttons: {
    add_integration: 'Aggiungi integrazione',
  },
  toasts: {
    error: 'Salvataggio delle modifiche non riuscito',
    success: 'Modifiche salvate',
    load_error: 'Caricamento integrazioni non riuscito',
  },
};
